<template>
  <div>
    <v-container>
      <h1 class="pb-4 primary--text font-weight-bold">
        {{
          isEditCustomer ? "Update Admin Profile" : $t("customer.addCustomer")
        }}
      </h1>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="reRender">
          <v-row align="center">
            <v-col cols="12" sm="6" md="6" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('customer.firstName')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('customer.firstName')"
                  color="secondary"
                  type="text"
                  v-model="customerModelObj.firstName"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('customer.lastName')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('customer.lastName')"
                  color="secondary"
                  type="text"
                  v-model="customerModelObj.lastName"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0 ">
              <ValidationProvider
                v-slot="{ errors }"
                :rules="{ phone: 8, required: true }"
                :name="$t('customer.phone')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  class="numberClass"
                  :label="$t('customer.phone')"
                  color="secondary"
                  type="number"
                  v-model="customerModelObj.phone"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('customer.email')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('customer.email')"
                  color="secondary"
                  type="text"
                  v-model="customerModelObj.email"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0">
              <v-switch
                class="mt-0"
                v-model="customerModelObj.active"
                color="primary"
                :label="$t('landlord.isActive')"
              >
                <!-- <template #prepend>
                  <v-label class="pa-12">{{  }}</v-label>
                </template> -->
              </v-switch>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
              <v-text-field
                outlined
                disabled
                :error-messages="errors"
                dense
                :label="$t('customer.role')"
                color="secondary"
                type="text"
                v-model="customerModelObj.role"
              >
              </v-text-field>
            </ValidationProvider>
            </v-col> -->
            <v-col cols="12" sm="6" md="6" class="py-0 ">
              <ValidationProvider
                v-slot="{ errors }"
                :name="$t('customer.newPassword')"
                rules="minPass:6"
              >
                <v-text-field
                  :error-messages="errors"
                  outlined
                  dense
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  @click:append="show = !show"
                  :label="`New Password`"
                  color="secondary"
                  v-model="customerModelObj.newPassword"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <div cols="4" class="pe-3 ms-auto">
              <v-btn
                width="120"
                class="black--text me-2"
                color="#FFFFFFFF"
                outlined
                @click="onCancel"
              >
                {{ $t("common.cancel") }}
              </v-btn>

              <v-btn
                width="120"
                class="white--text"
                color="primary"
                type="submit"
                :loading="btnLoading"
              >
                {{ isEditCustomer ? $t("common.update") : $t("common.save") }}
              </v-btn>
            </div>
            <v-col v-if="isError != null" cols="12" sm="12"
              ><Alert :message="isError" />
            </v-col>
          </v-row>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import "@/core/methods/validation_rules";
import { mapGetters } from "vuex";
import { updateCustomer } from "@/user/methods/customer/updateCustomer";
export default {
  data() {
    return {
      reRender: 0,
      btnLoading: false,
      customerModelObj: {},
      isError: null,
      show: false
    };
  },
  components: {
    Alert: () => import("@/core/components/Alert.vue")
  },
  mounted() {
    if (this.isEditCustomer) {
      this.customerModelObj = this.$format.cloneVariable(this.editCustomer);
      this.customerModelObj.active = true;
    }
  },
  computed: {
    ...mapGetters(["isEditCustomer", "editCustomer"])
  },
  watch: {
    isEditCustomer: {
      handler() {
        if (this.isEditCustomer) {
          this.customerModelObj = this.$format.cloneVariable(this.editCustomer);
          this.customerModelObj.active = true;
        } else {
          this.customerModelObj = {
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            active: ""
          };
          this.reRender++;
        }
      },
      deep: true
    }
  },
  methods: {
    async onSave() {
      this.btnLoading = true;
      const input = this.$format.cloneVariable(this.customerModelObj);
      const updateInput = {
        id: input._id,
        input: {
          firstName: input.firstName,
          lastName: input.lastName,
          email: input.email,
          phone: input.phone,
          active: input.active,
          newPassword: input.newPassword
        }
      };
      updateCustomer(updateInput).then(response => {
        if (response.data) {
          this.btnLoading = false;
          this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
          this.$store.commit("IS_EDIT_CUSTOMER", false);
          this.$root.$emit("snackbar", {
            snackbar: true,
            text: this.$t("common.updateSuccess"),
            color: "green"
          });
        }
        if (response.graphQLErrors) {
          this.btnLoading = false;
          this.isError = response.graphQLErrors[0].message;
          setTimeout(() => {
            this.isError = null;
          }, 5000);
        }
      });
    },
    onCancel() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
      this.$store.commit("IS_EDIT_CUSTOMER", false);
      this.$store.commit("IS_ADMIN_PROFILE", false);
    }
  }
};
</script>
<style scoped>
.numberClass >>> input[type="number"] {
  -moz-appearance: textfield;
}
.numberClass >>> input::-webkit-outer-spin-button,
.numberClass >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
